import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/app-store-optimization/steps-to-maximize-efforts.webp";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose cms_path p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2 style={{ color: "#fff" }}>
              Maximize Your App Launch Efforts with <span>TekRevol</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p style={{ color: "#fff" }}>
              Our app store optimization services drive measurable growth,
              increased visibility, and sustained success for your mobile
              applications. We tailor strategies to ensure your app excels in
              competitive marketplaces with maximum reach and conversions
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>Higher App Store Ranking</h5>
                    <p>
                      Ensure top placement in app stores, enhancing
                      discoverability and increasing download potential
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>Global Market Adaptation</h5>
                    <p>
                      Optimize your app for international audiences with
                      comprehensive localization strategies
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>Custom ASO Reporting & Insights</h5>
                    <p>
                      Receive detailed, actionable insights with custom
                      reporting that tracks key performance indicators (KPIs)
                      and informs strategic adjustments.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Optimal User Acquisition Cost (CAC)</h5>
                    <p>
                      Reduce user acquisition costs with targeted ASO campaigns
                      that attract high-quality users at a lower cost per
                      install (CPI).
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>Grow In-App Purchases</h5>
                    <p>
                      Maximize your app’s monetization potential with tailored
                      strategies to increase in-app purchases and ad revenue.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>Sustained Organic Growth</h5>
                    <p>
                      Achieve long-term visibility and engagement through
                      consistent optimization efforts tailored to market trends.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
